import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CommonState } from '../store/reducer';
import { ServicesCommon } from './services-common.service';
import { ENVIRONMENT_TOKEN } from '../../environment/token-variables';
import {
  Lease,
  LeaseRequest, ShareLeaseDetailEmailRequest
} from '../model';

import { Store } from '@ngrx/store';
import { GenericIdTitle } from '../model/BaseModel';


@Injectable()
export class LeaseService {


  private readonly LEASE_URL = `/private/leases`;


  constructor(
    protected http: HttpClient,
    private servicesCommon: ServicesCommon,
    public store: Store<CommonState>,
    @Inject(ENVIRONMENT_TOKEN) private readonly environment
  ) {
  }

  public loadAllLeases(ranchId: number, year: number) {
    let path = `/private/leases/summaries/ranch/${ranchId}`;
    if (!!year) {
      path = `/private/leases/summaries/ranch/${ranchId}/year/${year}`;
    }
    return this.servicesCommon.getAll<Lease>(path);
  }

  public loadLeaseById(leaseId: number) {
    return this.servicesCommon.get<Lease>(
      `/private/leases/lease/${leaseId}`);
  }

  public loadLeaseByBoundaryId(boundaryId: number) {
    return this.servicesCommon.getAll<Lease>(
      `/private/leases/boundary/${boundaryId}`);
  }

  loadLeaseTerms() {
    return this.servicesCommon.getAll<GenericIdTitle>(
      `/private/leases/terms`);
  }

  loadLeaseTypes() {
    return this.servicesCommon.getAll<GenericIdTitle>(
      `/private/leases/types`);
  }

  loadLeaseCategories() {
    return this.servicesCommon.getAll<GenericIdTitle>(
      `/private/leases/categories`);
  }

  loadLeasePaymentDue() {
    return this.servicesCommon.getAll<GenericIdTitle>(
      `/private/leases/payment_due`);
  }

  createNewLease(request: LeaseRequest) {
    const url = this.LEASE_URL + '/lease';
    return this.http.post<any>(
      this.environment.backend + url,
      request,
      {headers: this.servicesCommon.getAuthHeaders()}
    );
  }

  updateLease(request: LeaseRequest) {
    const url = this.LEASE_URL + '/lease/' + request.id;
    return this.http.put<Lease>(
      this.environment.backend + url,
      request,
      {headers: this.servicesCommon.getAuthHeaders()}
    );
  }

  deleteLease(leaseId: number) {
    const url = this.LEASE_URL + '/lease/' + leaseId;
    return this.http.delete(
      this.environment.backend + url,
      {headers: this.servicesCommon.getAuthHeaders()}
    );
  }

  shareLeaseDetails(request: ShareLeaseDetailEmailRequest) {
    const url = this.LEASE_URL + '/lease/details/email/share';

    return this.http.post<any>(
      this.environment.backend + url,
      request,
      {headers: this.servicesCommon.getAuthHeaders()}
    );
  }
}
